import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import toast from "react-hot-toast";

import SectionHeader from "../components/SectionHeader";
import FilterSelect from "../components/FilterSelect";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import DataTable from "react-data-table-component";
import TableLoader from "../components/TableLoader";

import generateTimeEntryColumns from "../components/TimeEntries/generateTimeEntryColumns";

import timeEntryService from "../services/timeEntryService";

const typeOptions = [
  { value: 'work', label: 'Work' },
  { value: 'sick', label: 'Sick Leave' }
];

const LabourerTimeEntries = () => {
  const [timeEntries, setTimeEntries] = useState([]);
  const [timeEntryCount, setTimeEntryCount] = useState(0);
  const [timeEntryPage, setTimeEntryPage] = useState(1);
  const [timeEntryPerPage, setTimeEntryPerPage] = useState(10);

  const [isLoadingTimeEntries, setIsLoadingTimeEntries] = useState(false);

  const [selectedType, setSelectedType] = useState(null);
  const [dateRange, setDateRange] = useState(null);

  const fetchTimeEntries = async () => {
    setIsLoadingTimeEntries(true);

    try {
      const payload = {};

      if (selectedType) payload.type = selectedType.value;

      if (dateRange) {
        payload.startTime = dateRange[0].toISOString();
        payload.endTime = dateRange[1].toISOString();
      }

      if (timeEntryPage) payload.page = timeEntryPage;
      if (timeEntryPerPage) payload.perPage = timeEntryPerPage;

      const { timeEntries, count } = await timeEntryService.fetchTimeEntries(payload);

      setTimeEntries(timeEntries);
      setTimeEntryCount(count);
    } catch (error) {
      console.log(error);
      toast.error('Something went wrong while loading time entries. Please refresh this page');
    } finally {
      setIsLoadingTimeEntries(false);
    }
  };

  useEffect(() => {
    fetchTimeEntries();
  }, [timeEntryPage, timeEntryPerPage, selectedType, dateRange]);

  const handleTimeEntriesPageChange = async (page) => {
    setTimeEntryPage(page);
  }

  const handleTimeEntriesPerPageChange = async (page, newPerPage) => {
    setTimeEntryPerPage(newPerPage);
    setTimeEntryPage(page);
  };

  return (
    <>
      <Helmet>
        <title>My Time Entries | ASE Group</title>
      </Helmet>

      <div className='border border-ase-blue rounded-lg pb-1'>
        <SectionHeader
          title='Time Entries'
          actionsRight={(
            <div className='flex flex-col md:flex-row md:items-center gap-2 w-full'>
              <p className='text-white text-xs'>Type:</p>
              <div className='text-xs  h-[24px]'>
                <FilterSelect
                  options={typeOptions}
                  value={selectedType}
                  onChange={setSelectedType}
                  placeholder='Select type'
                />
              </div>

              <p className='text-white text-xs'>Period:</p>

              <DateRangePicker
                value={dateRange}
                onChange={setDateRange}
                format='dd/MM/y'
                className="filter-date-range"
              />
            </div>
          )}
        />

        <DataTable
          columns={generateTimeEntryColumns({
            showLabourerField: false
          })}
          data={timeEntries}
          striped
          highlightOnHover
          pagination
          paginationServer
          progressPending={isLoadingTimeEntries}
          progressComponent={<TableLoader />}
          paginationTotalRows={timeEntryCount}
          paginationRowsPerPageOptions={[5, 10, 20, 50]}
          paginationPerPage={timeEntryPerPage}
          onChangePage={handleTimeEntriesPageChange}
          onChangeRowsPerPage={handleTimeEntriesPerPageChange}
        />
      </div>
    </>
  )
};

export default LabourerTimeEntries;
